import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useMemo } from "react";

import { useGetMapZones } from "@/requests/transport.queries";

export type WeTrackZoneGroups = {
    area_groups: WeTrackZoneGroupData[];
    status: true;
};
export type WeTrackZoneGroupData = {
    id: number;
    name: string;
};
export type WeTrackZoneLocation = [number, number][];
export type WeTrackZoneData = {
    id: number;
    index: number;
    name: string;
    radius: number;
    deflection: null;
    location: WeTrackZoneLocation[];
};

export type WeTrackZoneDataWithGroup = WeTrackZoneData & {
    group: WeTrackZoneGroupData;
};

export type WeTrackZoneResponse = {
    points: WeTrackZoneData[];
    status: boolean;
};

export function useMapZonesDrawer(showZones: boolean) {
    const map = useMap();

    const { data: zones } = useGetMapZones();
    const parsedZones = useMemo(
        () =>
            zones?.map((zone: WeTrackZoneDataWithGroup) => {
                if (zone.location.length > 1) return;
                const points = zone.location[0].map((point) => {
                    return { lat: point[1], lng: point[0] };
                });
                return {
                    points,
                    type: zone.group.name,
                };
            }),
        [zones]
    );

    useEffect(() => {
        if (!map) return;

        const zonesRender = parsedZones?.map((zone) => {
            let color = "#0059b2";

            if (zone?.type === "Airports") {
                color = "#15803d";
            } else if (zone?.type === "Waiting Zones") {
                color = "#4f46e5";
            } else if (zone?.type === "Klinik") {
                color = "#bfdbfe";
            }

            return new google.maps.Polygon({
                paths: zone?.points,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 3,
                fillColor: "#000",
                fillOpacity: 0.25,
                editable: false,
                draggable: false,
                clickable: true,
                visible: showZones,
            });
        });

        zonesRender?.forEach((zone) => {
            zone.setMap(map);
        });

        return () => {
            zonesRender?.forEach((zone) => {
                zone.setMap(null);
            });
        };
    }, [map, zones, showZones, parsedZones]);
}
